import React from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { connect, ConnectedProps } from "react-redux"
import { RootState } from "../../store/store"
import BottomBar from "../BottomBar/bottombar"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import { SuccessTick } from "../index"
import momentZone from "moment-timezone"
import {
  helpBlueIcon,
  info,
  infoBlackIcon,
  calendar,
  arrowDownRight,
  arrowTopRight,
  Success
} from "../../images"
import "./checkIn.css"
import { toast } from "react-toastify"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import _ from "lodash"
import setFiles from "store/actions/fileAction"
import i18next from "i18next"

const mapStateToProps = (state: RootState) => ({
  facility: state.facilityReducer.facility,
  driver: state.driverReducer.driver,
  visit: state.visitReducer.visit,
  appointment: state.appointmentReducer.appointment,
  location: state.locationReducer.location,
  files: state.fileReducer.files
})

const mapDispatchToProps = {
  setFiles: (file: Array<Object>) => setFiles(file)
}

const connector = connect(mapStateToProps, mapDispatchToProps)
let timerID: ReturnType<typeof setTimeout>
type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & RouteComponentProps

interface State {
  buttonDisabled: boolean
  successDisable: boolean
  successEnable: boolean
  scheduledTime: any
  showDate: string
  showTime: string
  showTimeZone: string
}

interface appointmentDetailProps {
  header: string
  icon: string
  Appointment: any
}

const appointmentDetails = (props: appointmentDetailProps) => {
  return (
    <>
      <div className="accord-header">
        <img
          className="accord-header-image"
          src={props.icon === "arrowDownRight" ? arrowDownRight : arrowTopRight}
          alt={props.icon}
        />
        <div className="accord-header-text">{props.header}</div>
      </div>
      <div>
        {props.Appointment.map((item: any) => {
          return (
            <div className="accord-items" key={item.key}>
              <div className="accord-item-key">{item.key}</div>
              <div className="accord-item-value">{item.value}</div>
            </div>
          )
        })}
      </div>
    </>
  )
}

class CheckIn extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      buttonDisabled: false,
      successDisable: false,
      successEnable: false,
      scheduledTime: "",
      showDate: "",
      showTime: "",
      showTimeZone: ""
    }
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.appointment.details[0]?.scheduledTime)) {
      const offset = this.props.appointment.details[0]?.timezone.offset
      const offsetDate = momentZone(
        this.props.appointment.details[0]?.scheduledTime
      ).utcOffset(offset / 3600)
      this.setState({
        showTimeZone: this.props.appointment.details[0]?.timezone?.name,
        showDate: `${offsetDate.format("dddd")},
                  ${offsetDate.format("MMM DD")}`,
        showTime: `${offsetDate.format("LT")}`,
        scheduledTime: offsetDate.format("llll")
      })
    }
  }

  submitCheckIn = () => {
    const { facility } = this.props.visit?.visit
    const modules = facility?.configuration?.modules
    const edocsAvailable = modules.filter(
      (module: any) => module.name === "edocs"
    )
    const visitId =
      this.props.appointment.matchingVisitDetails?.id || this.props.visit.id

    http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: "check-in"
        },
        {}
      )
      .then(() => {
        this.setState({ successDisable: true })
        timerID = setTimeout(() => {
          this.setState({ successDisable: false, successEnable: true })
          this.props.history.push("/edocs")
        }, 2000)
      })
      .catch(err => toast.error(err.response.data.error))
  }

  componentWillUnmount() {
    clearTimeout(timerID)
  }

  render() {
    return (
      <>
        <div className={`container`}>
          <SuccessTick
            message={i18next.t("check_in_successful")}
            proceedMessage=""
            visible={this.state.successDisable}
          />
          <div className="appointment-details-info">
            <div className="card">
              <div className="rectangle">
                <img
                  className="appointment-details-info-img"
                  src={infoBlackIcon}
                  alt="info"
                />
                <div className="appointment-details-info-text">
                  {i18next.t("appointment_details")}
                </div>
              </div>
              <div className="appointment-type">
                <div className="appointment-type-text">
                  {this.props.appointment.type.split("_")[0]}
                </div>
              </div>
              <div className="line"></div>
              <div className="appointment-date-time">
                <img
                  className="appointment-date-time-img"
                  src={calendar}
                  alt="calendar"
                />
                <div className="appointment-date-time-text">
                  <div className="date-day">
                    {_.isEmpty(this.state.showDate)
                      ? "NA"
                      : this.state.showDate}
                  </div>
                  <div className="date-time">
                    {_.isEmpty(this.state.showTime)
                      ? "NA"
                      : `${this.state.showTime} ${this.state.showTimeZone}`}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="warning-info">
            <img className="warning-info-img" src={info} alt="info" />
            <div className="warning-info-text">{i18next.t("scroll_text")}</div>
          </div>
          <div className="accord-container">
            {this.props.appointment.details.map((detail: any) => {
              const offset = detail.timezone.offset
              const offsetDate = momentZone(detail.scheduledTime).utcOffset(
                offset / 3600
              )
              /* const detailsTime = _.isEmpty(detail.scheduledTime)
                ? ""
                : new Date(detail.scheduledTime) */
              let carrierName = detail.equipment.carrier.name
              if (detail.equipment.carrier.scac !== "") {
                carrierName = `${detail.equipment.carrier.name} [ ${detail.equipment.carrier.scac}]`
              }
              return appointmentDetails({
                header: detail.direction || "Inbound",
                icon:
                  detail.direction !== "Inbound"
                    ? "arrowTopRight"
                    : "arrowDownRight",
                Appointment: [
                  {
                    key: "Reference Number",
                    value: detail.loadNumber || "NA"
                  },
                  {
                    key: "Appointment Time",
                    value:
                      detail.scheduledTime === ""
                        ? "NA"
                        : `${offsetDate.format("ddd")}, ${offsetDate.format(
                            "MMM DD"
                          )} ${this.state.showTime} ${this.state.showTimeZone}`
                  },
                  {
                    key: "Equipment Type",
                    value: detail.equipment.type || "NA"
                  },
                  {
                    key: "Equipment ID",
                    value: detail.equipment.id || "NA"
                  },
                  {
                    key: "Equipment Carrier",
                    value: carrierName || "NA"
                  }
                ]
              })
            })}
          </div>
          <div
            className="check-in-help"
            onClick={() => {
              this.props.history.push("/support")
            }}
          >
            <img src={helpBlueIcon} alt="help" className="vert-bottom" />
            <span className="check-in-help-text">
              {i18next.t("find_anything_wrong")}
            </span>
          </div>
        </div>
        {!this.state.successEnable && (
          <BottomBar
            disabled={this.state.successEnable}
            onClick={() => {
              this.submitCheckIn()
            }}
            text={i18next.t("check_in")}
            endIcon={<KeyboardArrowRightIcon />}
          />
        )}
      </>
    )
  }
}

export default withRouter(connector(CheckIn))
